import React from 'react';
import { motion } from 'framer-motion';
import { CpuIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-yellow bg-brand-navy text-white" data-id="element-94" data-mp="4m8ku8bjujit">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-4 text-center sm:px-5" data-id="element-95" data-mp="1297cg4ndx19u">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full border border-brand-yellow/60 px-2.5 py-1 text-[0.62rem] font-extrabold uppercase tracking-[0.14em] text-brand-yellow" data-id="element-96" data-mp="1274odq5sli7r">
          <CpuIcon size={11} data-id="element-97" data-mp="3d2l9jc5qb50p" />
          Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.75rem] uppercase leading-[1.05] text-white sm:text-[2.6rem]" data-id="element-98" data-mp="3825w6klg5xiq">
          El sistema completo para aprender{' '}
          <span className="text-brand-yellow" data-id="element-99" data-mp="39a38f34q1jod">Automatización Industrial y PLC</span>{' '}
          desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-2 max-w-xl text-[0.8rem] font-medium leading-snug text-white/85 sm:text-[0.92rem]" data-id="element-100" data-mp="30i19j9aawbg7">
          Aprende una habilidad técnica actual, comprende cómo funcionan los
          sistemas automatizados y prepárate para comenzar a desarrollar
          proyectos con PLC, sensores y actuadores — sin perderte entre cientos
          de videos, programas y tutoriales.
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2.5 inline-flex items-center gap-1.5 rounded-md bg-brand-yellow px-3 py-1.5 text-[0.65rem] font-extrabold uppercase leading-tight tracking-wide text-brand-carbon sm:text-xs" data-id="element-101" data-mp="2lml8gkbazfab">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.a>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2.5 block overflow-hidden rounded-xl border-4 border-brand-yellow bg-brand-steel" data-id="element-102" data-mp="1b04at0li8t2j">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-103" data-mp="3lsysay1o8kij" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-104" data-mp="3htq03xma4up3">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-105" data-mp="218juptknid2b">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.68rem] font-semibold text-white/85" data-id="element-106" data-mp="2b0fx3gtrspcc">
            <span className="flex items-center gap-1" data-id="element-107" data-mp="2fz0wje1774zq">
              <ZapIcon size={12} className="text-brand-yellow" data-id="element-108" data-mp="2kyvqxrk6mcpj" />
              Acceso Digital Inmediato
            </span>
            <span className="text-white/50" data-id="element-109" data-mp="2p08ufuzsy3ta">•</span>
            <span className="flex items-center gap-1" data-id="element-110" data-mp="2oye6s8x5bxli">
              <ShieldCheckIcon size={12} className="text-brand-yellow" data-id="element-111" data-mp="2tyiqe7tcp8fy" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}